/* template */
<template><mpx-view @tap="toManagePassengers" class="container"><div class="info"><mpx-image :src="(userIcon)" class="user-icon"></mpx-image><div>常用乘车人</div></div><div class="entrance"><div v-if="(travelerNumber)">{{travelerNumber}}位</div><es-icon size="16" name="angle-right"></es-icon></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m645f23c6"}'>
.container
  border-radius 8px
  box-sizing border-box
  height 56px
  background #F8F9FD
  @extend .flex-center
  justify-content space-between
  padding 14px 8px 14px 16px
  margin-top 86px
  font-weight normal
  line-height 1
  letter-spacing 0px
  .info, .entrance
    @extend .flex-center
  .info
    font-family PingFangSC-Medium
    font-size 16px
    color #000000
    .user-icon
      width 28px
      height 28px
      margin-right 8px
  .entrance
    font-family PingFangSC-Regular
    font-size 12px
    color #666666
	
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m645f23c6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./passengers.mpx.js?isComponent&outputPath=components%2Fpassengers645f23c6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./passengers.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpassengers645f23c6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m645f23c6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/passengers645f23c6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
